<template>
  <div class="button-group" :class="{ 'is-invalid': invalid }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ButtonGroup',
  props: {
    invalid: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@sass/design-system/variables" as ds-variables;
@use "@sass/base/variables" as variables;

$border-radius: 8px;

.button-group {
  display: flex;
  width: 100%;
  box-sizing: border-box;

  & > :deep(.is-active) {
    background-color: ds-variables.$green;
    border-color: ds-variables.$green;
    color: ds-variables.$white;

    &:hover {
      background-color: ds-variables.$green-400;
      border-color: ds-variables.$green-400;
    }
  }

  &.is-invalid {
    & > :deep(.is-active) {
      background-color: ds-variables.$red;
    }

    & > :deep(*) {
      border-color: ds-variables.$red;

      &:hover {
        border-color: ds-variables.$red;
      }
    }
  }
}

.button-group > :deep(*) {
  background-color: ds-variables.$white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  border: 1px solid ds-variables.$grey-500;
  font-weight: 600;
  border-left-width: 0;

  &:first-child {
    border-radius: $border-radius 0 0 $border-radius;
    border-left-width: 1px;
  }

  &:last-child {
    border-radius: 0 $border-radius $border-radius 0;
  }

  &:hover {
    background-color: ds-variables.$grey-100;
  }

  &:focus {
    position: relative;
    z-index: 1;
  }
}
</style>
